import axios from "axios";

export const saveImageToStorageFunctionService = async (image) => {
  try {
    const data = await axios.post(
      "https://us-central1-cook-e-ai.cloudfunctions.net/saveImageToStorage",
      {
        imageUrl: image,
      }
    );
    return data?.data?.downloadURL;
  } catch (e) {
    console.log(e);
    return null;
  }
};
